import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useTranslation } from "react-i18next";

const RTL_LANGUAGES = ["ar"];

// The pages clients open, translated into all the client languages; the dashboard only exists in left-to-right ones.
const PUBLIC_PAGES =
  /^\/(user\/[^/]+\/registration|process|loyalty-program|event|business-card|custom-registration|unsubscribe|sign|booking|registration-complete|link-unavailable|user\/reset-password|passless|login\/[^/]+)(\/|$)/;

export const publicPageDirection = (
  pathname: string,
  language: string | undefined
): "rtl" | "ltr" =>
  PUBLIC_PAGES.test(pathname) &&
  RTL_LANGUAGES.includes((language || "").split("-")[0])
    ? "rtl"
    : "ltr";

/** Sets the direction of the whole document for the client pages, so that every one of them reads right to left in Arabic. */
export const usePublicPageDirection = () => {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  useEffect(() => {
    document.documentElement.dir = publicPageDirection(pathname, i18n.language);
  }, [pathname, i18n.language]);
};
